'use client'

import SalesForceForm from './SalesForceForm'

type ContactForm = {
	salesForceFormUrl: string
}

export default function ContactForm({ salesForceFormUrl }: ContactForm) {
	return (
		<div className="max-w-[600px] mx-auto mb-16">
			<SalesForceForm formUrl={salesForceFormUrl} />
		</div>
	)
}
